//messages.js
export default {
    document_id: "Document Id",
    document_type: "Document Type",
    device: "Device",
    billing_address_id: "Billing Address Id",
    shipping_address_id: "Shipping Address",
    ship_location_label: "Ship Location Label",
    ship_address1: "Ship Address1",
    ship_address2: "Ship Address2",
    ship_city: "Ship City",
    ship_state: "Ship State",
    ship_zip_code: "Ship Zip Code",
    ship_zip_code_ext: "Ship Zip Code Ext",
    ship_country_iso_3: "Ship Country Iso 3",
    bill_location_label: "Bill Location Label",
    bill_address1: "Bill Address1",
    bill_address2: "Bill Address2",
    bill_city: "Bill City",
    bill_state: "Bill State",
    bill_zip_code: "Bill Zip Code",
    bill_zip_code_ext: "Bill Zip Code Ext",
    bill_country_iso_3: "Bill Country Iso 3",
    shipping_carrier_id: "Shipping Carrier Id",
    document_date: "Document Date",
    due_date: "Due Date",
    payment_term_id: "Payment Term Id",
    approved: "Approved",
    currency_id: "Currency Id",
    exchange_rate: "Exchange Rate",
    status_id: "Status Id",
    work_order_no: "Work Order No",
    subtotal: "Subtotal",
    discount: "Discount",
    discount_type: "Discount Type",
    freight: "Freight",
    expedite_fee: "Expedite Fee",
    handling_charge: "Handling Charge",
    customs: "Customs",
    total_amount: "Total Amount",
    balance: "Balance",
    document_subtotal: "Document Subtotal",
    document_discount: "Document Discount",
    document_freight: "Document Freight",
    document_expedite_fee: "Document Expedite Fee",
    document_handling_charge: "Document Handling Charge",
    document_customs: "Document Customs",
    document_total_amount: "Document Total Amount",
    customer_po: "Customer Po",
    comments: "Comments",
    department_id: "Department Id",
    edit_transaction_document: "Edit Order",
    add_transaction_document: "Add Order",
    delete_transaction_document: "Delete Order",
    // transaction_documents: 'Transaction Documents',
    delete_transaction_document_confirm: "This action is not reversible!",
    transaction_documents: "Orders",
    orders: "Orders",
    department: "Department",
    order_number: "Order #",
    delivery_location: "Delivery Location",
    expected_delivery_date: "Expected Delivery Date",
    order_date: "Order Date",
    delivery_address: "Delivery Address",
    delete_transaction_document_payment: "Delete Payment",
    order_quantity: "Order Quantity",
    available_capacity: "Available Capacity",
    save_as_draft: "Save as Draft",
    mark_as_waiting_for_shipment: "Mark as Waiting for Shipment",
    transaction_document_locked: "This order is locked and cannot be edited as 1 or more products is on a shipment.",
};
